import { render, staticRenderFns } from "./PVSystemCharts.vue?vue&type=template&id=3565bca0&scoped=true&"
import script from "./PVSystemCharts.vue?vue&type=script&lang=ts&"
export * from "./PVSystemCharts.vue?vue&type=script&lang=ts&"
import style0 from "./PVSystemCharts.vue?vue&type=style&index=0&id=3565bca0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3565bca0",
  null
  
)

export default component.exports